import type { Hit } from '@algolia/client-search';
import type { BaseHit } from 'instantsearch.js/es/types';

import { type GetAlgoliaInsightsProps } from './types';

interface InsightInfoHit extends Hit<BaseHit> {
  regionalAttributes: {
    [key: string]: {
      promotionalPrice: number;
    };
  };
}

export const getAlgoliaInsights = () =>
  JSON.parse(
    localStorage.getItem('__algoliaInsights__') ?? 'null'
  ) as GetAlgoliaInsightsProps | null;

export const setInsightsInfo = (
  hit: InsightInfoHit,
  region: string,
  indexName: string
) => {
  const hitObj = {
    indexName,
    objectID: hit.objectID,
    queryID: hit.__queryID,
    position: hit.__position,
    price: hit.regionalAttributes[region].promotionalPrice,
    currency: 'BRL',
    quantity: 1,
  };

  localStorage.setItem('__algoliaInsights__', JSON.stringify(hitObj));
};
